import React from 'react';
import { useStorages } from '../../services/Firestore/Resources';
import Storage from './Storage';

export const StorageView = ({ classes, storage }) => {
  const [allStoragesInRootLocation, allStoragesInRootLocationLoading] = useStorages({
    where: [
      { field: 'lineage', op: 'array-contains', value: storage.lineage[0] },
      { field: 'deleted', op: '==', value: false },
    ],
  });

  const storageIds = allStoragesInRootLocation.map((storage) => storage.id);
  if (allStoragesInRootLocationLoading) return '';
  return <Storage storage={storage} storages={allStoragesInRootLocation} storageIds={storageIds} />;
};
export default StorageView;
